module.exports = __webpack_public_path__ + "static/img/suggest.af99574e.jpg";